import { RouteObject } from "react-router-dom";
import { lazy, ReactNode, Suspense } from "react";
import routePaths from "./routePaths";
const ForgetPassword = lazy(() => import("../screens/onBoarding/ForgetPassword/ForgetPassword"));
const ManageOnboardingNavigation = lazy(() => import("../screens/onBoarding/ManageOnboardingNavigation"));
const OTPVerify = lazy(() => import("../screens/onBoarding/OTPVerify/OTPVerify"));
const ResetPassword = lazy(() => import("../screens/onBoarding/ResetPassword/ResetPassword"));
const LoginPage = lazy(() => import("../screens/onBoarding/Login/Login"));
const SignupPage = lazy(() => import("../screens/Signup/Signup"));

const errorElement = () => {
    return <div>error </div>;
};

const getProtectedComponent = (component: ReactNode) => {
    return (<><ManageOnboardingNavigation /> {component}  </>);
};

const PublicRoutes: RouteObject[] = [
    {
        path: routePaths.HOME.path,
        element: <Suspense fallback={<></>}>{getProtectedComponent(<LoginPage />)}</Suspense>,
        caseSensitive: false,
        id: routePaths.LOGIN.id,
        errorElement: errorElement(),
        children: [
            { path: routePaths.LOGIN.path, element: getProtectedComponent(<LoginPage />) }
        ]
    },
    // {
    //     path: routePaths.SIGNUP.path,
    //     element: <Suspense fallback={<></>}>{<SignupPage />}</Suspense>,
    //     caseSensitive: false,
    //     id: routePaths.SIGNUP.id,
    //     errorElement: errorElement()
    // },
    {
        path: routePaths.FORGET_PASSWORD.path,
        element: <Suspense fallback={<></>}>{getProtectedComponent(<ForgetPassword />)}</Suspense>,
        caseSensitive: false,
        id: routePaths.FORGET_PASSWORD.id,
        errorElement: errorElement()
    },
    {
        path: routePaths.FORGET_PASSWORD_VERIFY_OTP.path,
        element: <Suspense fallback={<></>}>{getProtectedComponent(<OTPVerify />)}</Suspense>,
        caseSensitive: false,
        id: routePaths.FORGET_PASSWORD_VERIFY_OTP.id,
        errorElement: errorElement()
    },
    {
        path: routePaths.RESET_PASSWORD.path,
        element: <Suspense fallback={<></>}>{getProtectedComponent(<ResetPassword />)}</Suspense>,
        caseSensitive: false,
        id: routePaths.RESET_PASSWORD.id,
        errorElement: errorElement()
    }


];

export default PublicRoutes;